import React from 'react';
import compose from '../hoc/compose';
import displayNames from './displayNames';

var ContextMenuContent = function ContextMenuContent(props) {
  return /*#__PURE__*/React.createElement('div', {
    className: props.getClassName('context-menu-content-wrapper')
  }, props.children);
};

ContextMenuContent.displayName = displayNames.CONTEXT_MENU_CONTENT;
ContextMenuContent.propTypes = {};
export default compose(ContextMenuContent);